import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var breakpoints = {
  xs: '320px',
  sm: '480px',
  md: '767px',
  lg: '991px',
  xl: '1024px',
  xxl: '1272px'
};
var desktop = {
  min: _parsePxStringToInt(breakpoints.xl),
  max: null
};
var tabletLarge = {
  min: _parsePxStringToInt('992px'),
  max: _parsePxStringToInt('1023px')
};
var tablet = {
  max: _parsePxStringToInt(breakpoints.lg),
  min: _parsePxStringToInt('768px')
};
var mobileLarge = {
  max: _parsePxStringToInt(breakpoints.md),
  min: _parsePxStringToInt(breakpoints.sm)
};

var ViewportManager = /*#__PURE__*/function () {
  function ViewportManager(config) {
    _classCallCheck(this, ViewportManager);

    this.viewport = this._calculateInitialViewport();
    if (!global.callbacks) global.callbacks = {};
  }

  _createClass(ViewportManager, [{
    key: "register",
    value: function register(_ref) {
      var _this = this;

      var maxMobile = _ref.maxMobile,
          maxMobileLarge = _ref.maxMobileLarge,
          maxTablet = _ref.maxTablet,
          maxTabletLarge = _ref.maxTabletLarge,
          minDesktop = _ref.minDesktop;
      var self = this;
      var desktopQuery = "screen and (min-width:".concat(minDesktop, ")"); // 1024 - any

      var tabletLargeQuery = "screen and (min-width: 992px) and (max-width:".concat(maxTabletLarge, ")"); // 992 - 1023

      var tabletQuery = "screen and (min-width: 768px) and (max-width:".concat(maxTablet, ")"); // 768 - 991

      var mobileLargeQuery = "screen and (min-width: 480px) and (max-width:".concat(maxMobileLarge, ")"); // 480 - 767

      var mobileQuery = "screen and (max-width:".concat(maxMobile, ")"); // any - 479

      if (this.registered) return;

      if (typeof window !== 'undefined') {
        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var enquire;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return import('enquire.js');

                case 2:
                  enquire = _context.sent;
                  //If it goes from TabletLarge to Desktop
                  enquire.register(desktopQuery, {
                    match: function match() {
                      self._changeViewport('desktop', 'desktop');
                    }
                  }); // If it goes from tablet to tabletLarge

                  enquire.register(tabletLargeQuery, {
                    match: function match() {
                      self._changeViewport('desktop', 'tabletLarge');
                    }
                  }); //If it goes from Desktop to Tablet

                  enquire.register(tabletQuery, {
                    match: function match() {
                      self._changeViewport('tablet', 'tablet');
                    }
                  }); //If it goes from mobile to mobileLarge

                  enquire.register(mobileLargeQuery, {
                    match: function match() {
                      self._changeViewport('mobile', 'mobileLarge');
                    }
                  }); //If it goes from Tablet to Mobile

                  enquire.register(mobileQuery, {
                    match: function match() {
                      self._changeViewport('mobile', 'mobile');
                    }
                  });
                  _this.registered = true;

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    }
  }, {
    key: "unregister",
    value: function unregister(_ref3) {
      var maxMobile = _ref3.maxMobile,
          maxMobileLarge = _ref3.maxMobileLarge,
          maxTablet = _ref3.maxTablet,
          maxTabletLarge = _ref3.maxTabletLarge,
          minDesktop = _ref3.minDesktop;
      var desktopQuery = "screen and (min-width:".concat(minDesktop, ")"); // 1024 - any

      var tabletLargeQuery = "screen and (min-width: 992px) and (max-width:".concat(maxTabletLarge, ")"); // 992 - 1023

      var tabletQuery = "screen and (min-width: 768px) and (max-width:".concat(maxTablet, ")"); // 768 - 991

      var mobileLargeQuery = "screen and (min-width: 480px) and (max-width:".concat(maxMobileLarge, ")"); // 480 - 767

      var mobileQuery = "screen and (max-width:".concat(maxMobile, ")"); // any - 479

      if (!this.registered) return;

      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var enquire;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return import('enquire.js');

              case 2:
                enquire = _context2.sent;
                enquire.unregister(desktopQuery);
                enquire.unregister(tabletLargeQuery);
                enquire.unregister(tabletQuery);
                enquire.unregister(mobileLargeQuery);
                enquire.unregister(mobileQuery);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    } // Grab expanded variable from HOC component

  }, {
    key: "subscribe",
    value: function subscribe(id, expanded, cb) {
      global.callbacks[id] = {
        callbackFn: cb,
        expanded: expanded
      };
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(id) {
      delete global.callbacks[id];
    }
  }, {
    key: "_calculateInitialViewport",
    value: function _calculateInitialViewport() {
      if (typeof window === 'undefined') return;
      var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var viewport;
      var expandedViewport; // >= 1024

      if (width >= desktop.min) {
        viewport = 'desktop';
        expandedViewport = 'desktop';
      } else if (width >= tabletLarge.min && width < desktop.min) {
        // 992 <= x < 1024
        viewport = 'tablet';
        expandedViewport = 'tabletLarge';
      } else if (width >= tablet.min && width < tabletLarge.min) {
        // 768 <= x < 992
        viewport = 'tablet';
        expandedViewport = 'tablet';
      } else if (width >= mobileLarge.min && width < tablet.min) {
        // 480 <= x < 768
        viewport = 'mobile';
        expandedViewport = 'mobileLarge';
      } else if (width >= 0 && width < mobileLarge.min) {
        // 0 <= x < 480
        viewport = 'mobile';
        expandedViewport = 'mobile';
      }

      return {
        normalViewport: viewport,
        expandedViewport: expandedViewport
      };
    }
  }, {
    key: "_changeViewport",
    value: function _changeViewport(normalViewport, expandedViewport) {
      this.viewport = {
        normalViewport: normalViewport,
        expandedViewport: expandedViewport
      }; // Will fire when component first mounted

      var callbackKeys = Object.keys(global.callbacks);

      if (callbackKeys.length > 0) {
        callbackKeys.forEach(function (key) {
          if (global.callbacks && global.callbacks[key] && global.callbacks[key].callbackFn) {
            // If the callback object has expanded variable true,
            // send expandedViewport
            global.callbacks[key].expanded ? global.callbacks[key].callbackFn(expandedViewport) : global.callbacks[key].callbackFn(normalViewport);
          }
        });
      }
    }
  }]);

  return ViewportManager;
}();

export default new ViewportManager(); //Helpers

function _parsePxStringToInt(string) {
  if (typeof string == 'number') return string;
  if (!string.indexOf('px')) return parseInt(string);
  return parseInt(string.split('px')[0]);
}